export default __webpack_public_path__ + "static/media/tripledots.30bd3a7d.svg";